const registerListeners = ({ xhr, progress, resolve }) => {
  xhr.upload.addEventListener('progress', (event) => {
    if (!progress) return false
    return progress(Math.round((event.loaded / event.total) * 100))
  })

  xhr.addEventListener('load', () => {
    let response
    try {
      response = JSON.parse(xhr.response)
    } catch (e) {
      response = xhr.response
    }
    resolve({
      response,
      error: xhr.status < 200 || xhr.status >= 300,
      status: xhr.status,
    })
  })

  xhr.addEventListener('error', (error) => {
    resolve({ error, status: xhr.status, response: xhr.response })
  })

  xhr.addEventListener('abort', (aborted) => {
    resolve({ aborted })
  })
}

export const UploadRequest = ({
  request,
  files,
  instance,
  progress,
  headers,
}) =>
  new Promise((resolve) => {
    const xhr = new XMLHttpRequest()
    if (instance) instance(xhr)

    registerListeners({ xhr, resolve, progress })

    xhr.open(request.method || 'POST', request.url)
    xhr.withCredentials = request.withCredentials || false

    if (headers) {
      Object.keys(headers).forEach(header => xhr.setRequestHeader(header, headers[header]))
    }

    let formData = new FormData()

    if (request.fields) {
      Object.keys(request.fields).forEach((field) => {
        formData.append(field, request.fields[field])
      })
    }
    Array.from(files).forEach((file) => {
      return formData.append(file.uid || 'file', file)
    })
    xhr.send(formData)
  }
)



// WEBPACK FOOTER //
// ./src/utils/uploadFiles.js